import useTTNewsStartPage from '../CustomHooks/useTTNewsStartPage';
import Loader from '../GeneralComponents/Loader';
import PressCard from './PressCard';

const PressReleases = () => {
  const { data: news, isLoading } = useTTNewsStartPage();

  return (
    <>
      {!isLoading && (
        <div className="flex flex-no-wrap md:mx-auto md:pt-4 md:pb-1 w-full overflow-x-auto lg:overflow-x-hidden lg:overflow-y-visible scroll-snap-x">
          <ul className="flex md:justify-center gap-3 md:gap-6 mb-4 p-0">
            {news?.map((item) => (
              <PressCard
                key={item?.title + item?.published}
                item={item}
                customClasses="w-full min-w-[280px] scroll-snap-align-start scroll-snap-stop-normal mdplus:scroll-margin-init mdplus:scroll-snap-align-init mdplus:scroll-snap-stop-init "
              />
            ))}
          </ul>
        </div>
      )}
      {isLoading && (
        <div className="flex justify-center items-center py-16">
          <Loader />
        </div>
      )}
    </>
  );
};

export default PressReleases;
